// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_AnexarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /chamados/anexar — anexar UMA imagem a uma mensagem.
 *
 * `source(): 'upload'` é o que distingue este contrato dos outros do domínio: o
 * corpo é `multipart/form-data`, então `readInputData()` monta os dados a
 * partir de `$_POST` e injeta `$_FILES` em `_files`, em vez de ler o JSON de
 * `php://input` (que num multipart chega VAZIO).
 *
 * O que este contrato NÃO valida, de propósito: se o arquivo É uma imagem.
 * Isso depende de LER OS BYTES (`getimagesize`), e o controller faz. Um
 * contrato que se contentasse com o mime declarado pelo cliente daria uma
 * falsa sensação de validação sobre o valor exato que não se pode acreditar.
 */
import { registerContract } from './validate'

export interface Chamados_AnexarInput {
_files: unknown[]
chamado_id?: number
mensagem_id?: number
}

registerContract('Chamados_AnexarInput', {
  _files:      { type: 'array',   required: true },
  chamado_id:  { type: 'number',  required: false },
  mensagem_id: { type: 'number',  required: false },
})
